(function () {
    // --- ANG Extra Menu desktop display fix (flash-free) ---
    // Previously this fix only ran after the page finished loading, so the
    // header would briefly render in its default (broken) mobile-detection
    // state first — causing a visible flash of the hamburger icon before
    // correcting itself.
    //
    // This version intercepts the header component's own class definition
    // the moment it's registered (before any instance has connected to the
    // page), and replaces its width-detection logic before it ever runs for
    // the first time. That means there's no incorrect state to flash.
    var DESKTOP_BREAKPOINT = 1200; // px - normal desktop breakpoint
    var MOBILE_CLASS = 'js__show__mobile';

    function evaluate(header) {
        if (document.body.clientWidth < DESKTOP_BREAKPOINT) {
            header.classList.add(MOBILE_CLASS);
        } else {
            header.classList.remove(MOBILE_CLASS);
        }
        try {
            if (window.theme && typeof window.theme.readHeights === 'function') {
                var heights = window.theme.readHeights();
                if (heights && heights.headerHeight) {
                    document.documentElement.style.setProperty('--header-height', heights.headerHeight + 'px');
                }
            }
        } catch (e) {}
    }

    if (window.customElements && typeof window.customElements.define === 'function') {
        var originalDefine = window.customElements.define.bind(window.customElements);
        window.customElements.define = function (name, constructor, options) {
            if (name === 'header-component' && constructor && constructor.prototype) {
                constructor.prototype.getMinWidth = function () {
                    return DESKTOP_BREAKPOINT;
                };
                constructor.prototype.checkWidth = function () {
                    evaluate(this);
                };
            }
            return originalDefine(name, constructor, options);
        };
    }

    // Belt-and-suspenders safety net: keep enforcing the correct state in
    // case anything else (e.g. a resize handler bound before this script ran)
    // fights it, and catch any header-component added later (editor reloads).
    var enforcing = false;
    function enforce(header) {
        if (!header || enforcing) return;
        var shouldBeMobile = document.body.clientWidth < DESKTOP_BREAKPOINT;
        var isMobile = header.classList.contains(MOBILE_CLASS);
        if (shouldBeMobile !== isMobile) {
            enforcing = true;
            evaluate(header);
            enforcing = false;
        }
    }

    function watch(header) {
        header.minWidth = DESKTOP_BREAKPOINT;
        enforce(header);
        new MutationObserver(function () { enforce(header); }).observe(header, { attributes: true, attributeFilter: ['class'] });
    }

    function setupExisting() {
        document.querySelectorAll('header-component').forEach(watch);
    }

    if (document.readyState !== 'loading') {
        setupExisting();
    } else {
        document.addEventListener('DOMContentLoaded', setupExisting);
    }

    new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
            if (!m.addedNodes) return;
            m.addedNodes.forEach(function (node) {
                if (node.tagName === 'HEADER-COMPONENT') watch(node);
            });
        });
    }).observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener('resize', function () {
        document.querySelectorAll('header-component').forEach(enforce);
    });
})();
